import React from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';

const PopoverHeader = ({ cancelFilter }) => (
    <div className="ui-popoverHeader cmn-filter__popoverHeader">
        Choose Filters
        <button
            className="ui-btn ui-btn_secondary cmn-filter__crossBtn"
            onClick={cancelFilter}
        >
            <Svg isInlined iconName={'cross'} className="tableShowIcon" size="Medium" />
        </button>
    </div>
);

PopoverHeader.propTypes = {
    cancelFilter: PropTypes.func.isRequired,
};

export default PopoverHeader;



// WEBPACK FOOTER //
// ./~/rp-react-common/Filter/components/PopoverHeader.jsx